import React from "react";
import "./certification.css";
import { FaRegArrowAltCircleRight } from 'react-icons/fa';
const certifications = [
  {
    name : "Azure Associate Developer",
    link : "https://learn.microsoft.com/en-us/users/avanishkumarbind-9783/credentials/5c2234a872eb8f78?ref=https%3A%2F%2Fwww.linkedin.com%2F"
  },
  {
    name: "Azure Cloud Fundamentals",
    link: "https://learn.microsoft.com/en-us/users/avanishkumarbind-9783/credentials/54878d3394192ecf?ref=https%3A%2F%2Fwww.linkedin.com%2F"
  },
  {
    name: "Microsoft Azure AI",
    link: "https://learn.microsoft.com/en-us/users/avanishkumarbind-9783/credentials/29ff42f516268ef3"
  },
  {
    name: "C# Programming Language",
    link: "https://www.freecodecamp.org/certification/fcc08db2ecd-ca1b-40b5-a2b9-fdc4e504f670/foundational-c-sharp-with-microsoft"
  },
  {
    name: "SQL",
    link: "https://www.hackerrank.com/certificates/cf40f036c05f"
  },
  {
    name: "Problem Solving",
    link: "https://www.hackerrank.com/certificates/iframe/09a3d908f7a4"
  },
  {
    name: "Data Structure and Algorithms",
    link : "https://www.geeksforgeeks.org/certificate/ae284fdf6682fbba861162e0acb9ce66"
  }
];

const Certifications = () => {
  return (
    <section id="certifications">
      <h2 className="certifications__title">My Certifications</h2>
      <ul className="certifications__list">
        {certifications.map((cert, index) => (
          <li key={index} className="certifications__item">
            <a
              href={cert.link}
              target="_blank"
              rel="noopener noreferrer"
              className="certifications__link"
            >
              {cert.name}
              <FaRegArrowAltCircleRight/>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Certifications;
